<template>
  <div
    class="modal fade"
    id="import_item"
    aria-labelledby="exampleModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Import Stackholders</h5>
          <div class="d-flex align-items-center">
            <button
              class="btn-close custom-btn-close border p-1 me-0 text-dark"
              data-bs-dismiss="modal"
              aria-label="Close"
            >
              <i class="ti ti-x"></i>
            </button>
          </div>
        </div>
        <form @submit.prevent="submitForm">
          <div class="modal-body">
            <!-- File Upload Input -->
            <div class="mb-3">
              <label for="document" class="col-form-label">
                File Upload <span class="text-danger">*</span>
              </label>
              <input
                type="file"
                id="document"
                class="form-control"
                accept=".xlsx, .xls, .csv"
              />
            </div>
            <!-- Display Uploaded File Name -->
            <div v-if="forcastFile" class="mt-3">
              <strong>Uploaded File:</strong> {{ forcastFile }}
            </div>
          </div>
          <div class="modal-footer">
            <div class="d-flex align-items-center justify-content-end m-0">
              <a href="#" class="btn btn-light me-2" data-bs-dismiss="modal">
                Cancel
              </a>
              <button
                type="submit"
                class="btn btn-primary"
                :disabled="isLoading"
              >
                <span
                  v-if="isLoading"
                  class="spinner-border spinner-border-sm"
                ></span>
                Upload
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import readXlsxFile from "read-excel-file";
import http from "@/utils/http";

export default {
  data: () => ({
    isLoading: false,
    forcastFile: null, // Name of the uploaded file
    adjustmentFiles: [], // Parsed Excel rows
  }),

  mounted() {
    const input = document.getElementById("document");
    input.addEventListener("change", () => {
      readXlsxFile(input.files[0]).then((rows) => {
        this.adjustmentFiles = rows;
        this.forcastFile = input.files[0].name;
      });
    });

    this.$emitter.on("import-item-modal", (row) => {
      this.$handleModal("import_item", "toggle");
    });
  },

  methods: {
    async submitForm() {
      if (!this.adjustmentFiles.length) {
        this.$toast.error("No data found in the uploaded file.");
        return;
      }

      this.isLoading = true;
      const endpoint = `/stackholders-import`;
      const method = "post";

      // Prepare the data for submission (if needed, format rows here)
      const payload = {
        adjustmentFiles: this.adjustmentFiles,
      };

      try {
        // Submit the data to your API
        const response = await http[method](endpoint, payload);
        this.$toast.success(response.data.message);
        this.$handleModal("import_item", "hide");
        this.$emit("refresh");
      } catch (error) {
        if (error.response && error.response?.data?.errors) {
          error.response?.data?.errors.forEach((err) => {
            this.$toast.error(err);
          });
        }

        this.$toast.error(
          error.response?.data?.message || "Failed to upload data."
        );
        this.$handleModal("import_item", "hide");
        this.$emit("refresh");
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>
